
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.478","height":"14.555"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"パス 120","d":"M.367.34a1.2 1.2 0 00-.028 1.7l5.223 5.238-5.223 5.236a1.202 1.202 0 001.7 1.7l6.09-6.086a1.2 1.2 0 00.349-.811v-.038-.038a1.2 1.2 0 00-.344-.812L2.045.341A1.2 1.2 0 00.367.34z","fill":"#12b6d4"}})])
          )
        }
      }
    